import { CreateMetadataModeFormValue } from '~bank-contacts/types/forms'

export interface CreateModeSelectionFormProps {
  onSubmit: (value: CreateMetadataModeFormValue) => void
  onCancel: () => void
}
